<div
  class="card modern-card full-width"
>
  <div class="card-header border-0 pt-3 px-4 sticky-header">
    <div class="d-flex justify-content-between align-items-center">
      <div class="header-content">
        <h1 class="modern-header">Payment Management</h1>
      </div>
    </div>
  </div>

  <div class="card-body px-4 pb-4">
    <form
      [formGroup]="this.paymentForm"
      class="mb-5"
    >
      <h4 class="mb-4 text-light section-header d-flex justify-content-between align-items-center"
          (click)="showCreditCard = !showCreditCard">
        Credit Card Information
        <i class="fa" [class.fa-chevron-down]="showCreditCard" [class.fa-chevron-right]="!showCreditCard"></i>
      </h4>

      <div [collapse]="!showCreditCard" [isAnimated]="true">
      <!-- row 1: Payment Type & Card Number -->
      <div class="row mb-3 align-items-center">
        <div class="col-md-6 form-group d-flex align-items-center mb-md-0">
          <label class="form-label" for="payment_type">Payment Type:</label>
          <div class="d-flex align-items-center gap-2 flex-grow-1">
            <ng-select
              [items]="payment_types"
              [multiple]="false"
              [closeOnSelect]="true"
              appendTo="body"
              class="form-control text-uppercase p-0 border-0 bg-transparent flex-grow-1"
              formControlName="payment_type"
              id="payment_type"
            ></ng-select>
            <div class="d-flex gap-2 ms-2">
              <i class="fa-brands fa-cc-visa text-light fa-2x"></i>
              <i
                class="fa-brands fa-cc-mastercard text-primary-emphasis fa-2x"
              ></i>
              <i class="fa-brands fa-cc-discover text-secondary fa-2x"></i>
              <i class="fa-brands fa-cc-amex text-info fa-2x"></i>
            </div>
          </div>
        </div>
        <div class="col-md-6 form-group d-flex align-items-center mb-0">
          <label class="form-label" for="card_number">Card Number:</label>
          <input
            class="form-control flex-grow-1"
            type="text"
            id="card_number"
            formControlName="card_number"
          />
        </div>
      </div>

      <!-- row 2: Name on Card, Exp Date, CVV -->
      <div class="row mb-3 align-items-center">
        <div class="col-md-6 form-group d-flex align-items-center mb-md-0">
          <label class="form-label" for="card_name">Name on Card:</label>
          <input
            class="form-control flex-grow-1"
            type="text"
            id="card_name"
            formControlName="card_name"
          />
        </div>
        <div class="col-md-6 d-flex gap-3">
          <div class="form-group d-flex align-items-center mb-0 flex-grow-1">
            <label class="form-label" for="card_exp_date" style="width: 100px"
              >Exp Date:</label
            >
            <input
              class="form-control"
              type="text"
              id="card_exp_date"
              formControlName="card_exp_date"
              style="width: 100px"
            />
          </div>
          <div class="form-group d-flex align-items-center mb-0">
            <label class="form-label" for="card_cvv" style="width: 60px"
              >CVV:</label
            >
            <input
              class="form-control"
              type="text"
              id="card_cvv"
              formControlName="card_cvv"
              style="width: 80px"
            />
          </div>
        </div>
      </div>

      <!-- row 3: Billing Address -->
      <div class="row mb-3">
        <div class="col-12 form-group d-flex align-items-center mb-0">
          <label class="form-label" for="billing_address"
            >Billing Address:</label
          >
          <input
            class="form-control flex-grow-1"
            type="text"
            id="billing_address"
            formControlName="billing_address"
          />
        </div>
      </div>

      <!-- row 4: Billing Address 2 -->
      <div class="row mb-3">
        <div class="col-12 form-group d-flex align-items-center mb-0">
          <label class="form-label" for="billing_address2">Address 2:</label>
          <input
            class="form-control flex-grow-1"
            type="text"
            id="billing_address2"
            formControlName="billing_address2"
          />
        </div>
      </div>

      <!-- row 5: Zip, City, State -->
      <div class="row mb-3">
        <div class="col-12 form-group d-flex align-items-center mb-0">
          <label class="form-label" for="billing_zip_code"
            >Zip / City / St:</label
          >
          <div class="d-flex gap-3 flex-grow-1">
            <input
              class="form-control"
              type="text"
              id="billing_zip_code"
              formControlName="billing_zip_code"
              style="width: 120px"
              placeholder="Zip"
            />
            <input
              class="form-control flex-grow-1"
              type="text"
              id="billing_city"
              formControlName="billing_city"
              placeholder="City"
            />
            <input
              class="form-control"
              type="text"
              id="billing_state"
              formControlName="billing_state"
              style="width: 120px"
              placeholder="State"
            />
          </div>
        </div>
      </div>

      <!-- row 6: Phone & Email -->
      <div class="row mb-4">
        <div class="col-md-6 form-group d-flex align-items-center mb-md-0">
          <label class="form-label" for="billing_phone">Phone:</label>
          <input
            class="form-control flex-grow-1"
            type="text"
            id="billing_phone"
            formControlName="billing_phone"
          />
        </div>
        <div class="col-md-6 form-group d-flex align-items-center mb-0">
          <label class="form-label" for="billing_email">Email:</label>
          <input
            class="form-control flex-grow-1"
            type="email"
            id="billing_email"
            formControlName="billing_email"
          />
        </div>
      </div>

      <!-- Buttons -->
      <div class="row mt-4">
        <div class="col-12 d-flex justify-content-end">
          <button
            class="btn green-btn"
            style="width: 200px"
            (click)="savePayment()"
          >
            <i class="fa fa-save me-2"></i>Save Card Info
          </button>
        </div>
      </div>
      </div> <!-- end collapse: showCreditCard -->
    </form>

    <div class="payment-history-section border-secondary">
      <h4 class="mb-4 text-light section-header">Payment History</h4>
      <div class="grid-container mb-3" style="height: 300px">
        <ag-grid-angular
          id="dispo_list"
          style="width: 100%; height: 100%"
          class="modern-grid"
          
          [columnDefs]="columnDefs"
          [defaultColDef]="defaultColDef"
          [rowData]="paymentHistoryData"
          [animateRows]="true"
        ></ag-grid-angular>
      </div>
      <div class="alert alert-dark bg-dark-subtle border-secondary text-dark">
        <i class="fa fa-info-circle me-2"></i>
        Your next automatic payment will be on
        <span class="text-dark fw-bold">1/19/2025 place holder</span>
      </div>
    </div>
  </div>
</div>
